import { useNavigate } from "react-router-dom";
import {
    Grid2 as Grid,
    Box,
    TextField,
    Typography,
    Button,
    FormControlLabel,
    Checkbox,
    Autocomplete,
} from "@mui/material";
import * as yup from "yup";
import React, { useState } from "react";
import { useFormik } from "formik";
import bgImage from '../../assets/img/newimgaes/Property Services.jpeg'
import TextEditor from "../section-components/TextEditor";
import { Pageheader } from "./page-header";
import Toast from "../Toast";
import { RegisterProperty } from "../../services/propertyManagementService";

const validationSchema = yup.object({
    firstname: yup.string().required("First Name is required"),
    location: yup.string().required("Location is required"),
    email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
    number: yup.string().matches(
        /^(?:\+91|0)?[6789]\d{9}$/,
        "Please enter a valid Indian mobile number"
    ).required("Contact Number is required"),
    description: yup.string().required("Description is required"),
    acceptTerms: yup.boolean().oneOf([true], "You must accept terms and conditions"),
});
export const AddPropertyManagement = (props) => {
    const navigate = useNavigate();
    const [toastOpen, setToastOpen] = React.useState(false);
    const [toastMessage, setToastMessage] = React.useState("");
    const [typeOptions] = useState([
        { id: 1, label: "Apartment" },
        { id: 2, label: "Villa" },
        { id: 3, label: "Plot" },
        { id: 4, label: "Independent House" },
    ]);

    const initialValues = {
        firstname: "",
        lastname: "",
        location: "",
        email: "",
        number: "",
        description: "",
        ticketAccount: "",
        register: false,
        acceptTerms: false,
    };
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            console.log("Form values:", values);
            RegisterProperty(values)
                .then((res) => {
                    setToastMessage(res.message);
                    setToastOpen(true);
                    formik.resetForm(); 
                    // navigate("/post");
                })
                .catch((err) => {
                    setToastMessage("There was an error submitting the form. Please try again.");
                    setToastOpen(true);
                });
        },
    });
    return (
        <>
            {props.isPage && <Pageheader headertitle="Post A Job" bgImage={bgImage} />}
            <Box className='container py-4'>
                <h3>Register Your Property</h3>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="name" className="form-label">
                                First Name
                            </label>
                            <TextField
                                fullWidth
                                name="firstname"
                                placeholder="First Name"
                                value={formik.values.firstname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.firstname &&
                                    Boolean(formik.errors.firstname)}
                                helperText={formik.touched.firstname && formik.errors.firstname} />
                        </Grid>

                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="lastname" className="form-label">
                                Last Name
                            </label>
                            <TextField
                                fullWidth
                                name="lastname"
                                placeholder="Last Name"
                                value={formik.values.lastname}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lastname &&
                                    Boolean(formik.errors.lastname)}
                                helperText={formik.touched.lastname && formik.errors.lastname} />
                        </Grid>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="location" className="form-label">
                                Location
                            </label>
                            <TextField
                                fullWidth
                                name="location"
                                placeholder="Enter Property Location"
                                value={formik.values.location}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.location && Boolean(formik.errors.location)}
                                helperText={formik.touched.location && formik.errors.location}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="email" className="form-label">
                                Email
                            </label>
                            <TextField
                                fullWidth
                                name="email"
                                placeholder="Email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email} />
                        </Grid>
                        <Grid size={{ xs: 12, md: props?.isPage ? 6 : 12 }}>
                            <label htmlFor="number" className="form-label">
                                Contact Number
                            </label>
                            <TextField
                                fullWidth
                                name="number"
                                placeholder="Contact Number"
                                value={formik.values.number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.number && Boolean(formik.errors.number)}
                                helperText={formik.touched.number && formik.errors.number} />
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <label htmlFor="description" className="form-label">
                                Description
                            </label>
                            <TextEditor setFieldWithEditor={(newValue) => formik.setFieldValue('description', newValue)} />
                            {formik.touched.description &&
                                Boolean(formik.errors.description) && (
                                    <Typography color="error">
                                        {formik.errors.description}
                                    </Typography>
                                )}
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormControlLabel
                                control={<Checkbox
                                    name="register"
                                    checked={formik.values.register}
                                    onChange={formik.handleChange}
                                    color="primary" />}
                                label="Create an account to view your saved properties and searches." />
                            {formik.touched.register &&
                                Boolean(formik.errors.register) && (
                                    <Typography color="error">
                                        {formik.errors.register}
                                    </Typography>
                                )}
                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>
                            <FormControlLabel
                                control={<Checkbox
                                    name="acceptTerms"
                                    checked={formik.values.acceptTerms}
                                    onChange={formik.handleChange}
                                    color="primary" />}
                                label="I have read and agree to the Terms and Conditions, Privacy Policy and Cookies Policy." />
                            {formik.touched.acceptTerms &&
                                Boolean(formik.errors.acceptTerms) && (
                                    <Typography color="error">
                                        {formik.errors.acceptTerms}
                                    </Typography>
                                )}
                        </Grid>
                        <Grid
                            size={{ xs: 12, md: props?.isPage ? 12 : 12 }}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{
                                    marginTop: 2,
                                    backgroundColor: '#d8b035',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#c5a02f',
                                    },
                                    '@media (max-width: 600px)': {
                                        fontSize: '1rem',
                                    },
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                <Toast
                    open={toastOpen}
                    message={toastMessage}
                    onClose={() => setToastOpen(false)}
                    severity={toastMessage.includes('success') ? "success" : "error"}
                    autoHideDuration={6000}
                />
            </Box></>
    )
}